module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-37.bbf25780.png";